import testingApi from '@/api/testing';
import {mutationTypes} from '@/store/modules/testing/mutations';

export const actionsTypes = {
  getMetadataSelfTests: '[testing] get metadata self tests',
  getZeroRegistrySelfTests: '[testing] get zero registry self tests',
  getMetadataTest360: '[testing] get metadata test 360',
  getMetadataBySpec: '[testing] get metadata test by spec',

  getHistoryPulseTest360: '[testing] get history pulse test 360',
  getUserTest360: '[testing] get user test 360',
  getCommentsTest360: '[testing] get comments test 360',
  getApproversTest360: '[testing] get approvers test 360',
  getDescriptionTest360: '[testing] get description test 360',
  getQuestions: '[testing] get questions',
  getOpenQuestions: '[testing] get open questions',

  getMetadataPersonalTests: '[testing] get metadata personal tests',
  getMetadataBHPersonalTests: '[testing] get metadata bh personal tests',
  getBHPersonalBlock: '[testing] get bh personal block',
  getBHPersonalTest: '[testing] get bh personal test',
  getBHPersonalQuestion: '[testing] get bh personal question',
  getUrlPersonalTest: '[testing] get url for personal test',
  getLinkPersonalReport: '[testing] get link to the personal report',
  getVariantsPersonalReport: '[testing] get variants personal report',
  exportPersonalReport: '[testing] export personal report',

  getUserSurveys: '[testing] get user surveys',
  getUserTests: '[testing] get user tests',
  getUserFeedbacks: '[testing] get user feedbacks',

  saveAnswer: '[testing] save answer',
  saveOpenQuestionsAnswers: '[testing] save open questions answers',
  saveBHPersonalAnswer: '[testing] save bh personal answer',
  keepAliveBHPersonalTest: '[testing] keep-alive bh personal test',
  resetAnswers: '[testing] reset answers',
  saveResults: '[testing] save results',
  createReport: '[testing] create report',
  approveTest360: '[testing] approve test 360',
  setDescriptionTest360: '[testing] set description test 360',

  getRejectsTest360: '[testing] get rejects test 360',
  rejectTest360: '[testing] reject test 360',
};

const actions = {
  [actionsTypes.getMetadataSelfTests](context, userId) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getMetadataSelfTestsStart);
      testingApi
        .getMetadataSelfTests(userId, {})
        .then((response) => {
          context.commit(mutationTypes.getMetadataSelfTestsSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getMetadataSelfTestsFailure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getZeroRegistrySelfTests](context, userId) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getMetadataSelfTestsStart);
      testingApi
        .getMetadataSelfTests(userId, {zero_registry: true})
        .then((response) => {
          context.commit(mutationTypes.getZeroRegistrySelfTestsSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getMetadataSelfTestsFailure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getMetadataTest360](context, test360Id) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getMetadataTest360Start);
      testingApi
        .getMetadataTest360(test360Id)
        .then((response) => {
          context.commit(mutationTypes.getMetadataTest360Success, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getMetadataTest360Failure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getMetadataBySpec](context, {userId, specId, test360Id}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getMetadataBySpecStart);
      testingApi
        .getMetadataBySpec(userId, specId, test360Id)
        .then((response) => {
          context.commit(mutationTypes.getMetadataBySpecSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getMetadataBySpecFailure, result.response.data.message);
          reject(result);
        });
    });
  },

  [actionsTypes.getHistoryPulseTest360](context, test360Id) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getHistoryPulseTest360Start);
      testingApi
        .getHistoryPulseTest360(test360Id)
        .then((response) => {
          context.commit(mutationTypes.getHistoryPulseTest360Success, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getHistoryPulseTest360Failure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getUserTest360](context, test360Id) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getUserTest360Start);
      testingApi
        .getUserTest360(test360Id)
        .then((response) => {
          context.commit(mutationTypes.getUserTest360Success, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getUserTest360Failure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getCommentsTest360](context, test360Id) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getCommentsTest360Start);
      testingApi
        .getCommentsTest360(test360Id)
        .then((response) => {
          context.commit(mutationTypes.getCommentsTest360Success, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getCommentsTest360Failure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getApproversTest360](context, test360Id) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getApproversTest360Start);
      testingApi
        .getApproversTest360(test360Id)
        .then((response) => {
          context.commit(mutationTypes.getApproversTest360Success, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getApproversTest360Failure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getDescriptionTest360](context, test360Id) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getDescriptionTest360Start);
      testingApi
        .getDescriptionTest360(test360Id)
        .then((response) => {
          context.commit(mutationTypes.getDescriptionTest360Success, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getDescriptionTest360Failure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getQuestions](
    context,
    {userId, skillId, specId, typeId, blockId, zeroRegistry, testing360Id}
  ) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getQuestionsStart);
      testingApi
        .getQuestions(userId, skillId, specId, typeId, blockId, zeroRegistry, testing360Id)
        .then((response) => {
          context.commit(mutationTypes.getQuestionsSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getQuestionsFailure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getOpenQuestions](context, test360Id) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getOpenQuestionsStart);
      testingApi
        .getOpenQuestions(test360Id)
        .then((response) => {
          context.commit(mutationTypes.getOpenQuestionsSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getOpenQuestionsFailure, result.response.data.message);
          reject(result);
        });
    });
  },

  [actionsTypes.getMetadataPersonalTests](context, userId) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getMetadataPersonalTestsStart);
      testingApi
        .getMetadataPersonalTests(userId)
        .then((response) => {
          context.commit(mutationTypes.getMetadataPersonalTestsSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getMetadataPersonalTestsFailure,
            result.response.data.message
          );
          reject(result);
        });
    });
  },
  [actionsTypes.getMetadataBHPersonalTests](context, userId) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getMetadataBHPersonalTestsStart);
      testingApi
        .getMetadataBHPersonalTests(userId)
        .then((response) => {
          context.commit(mutationTypes.getMetadataBHPersonalTestsSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getMetadataBHPersonalTestsFailure,
            result.response.data.message
          );
          reject(result);
        });
    });
  },
  [actionsTypes.getBHPersonalBlock](context, blockId) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getBHPersonalBlockStart);
      testingApi
        .getBHPersonalBlock(blockId)
        .then((response) => {
          context.commit(mutationTypes.getBHPersonalBlockSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getBHPersonalBlockFailure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getBHPersonalTest](context, {blockId, testId}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getBHPersonalTestStart);
      testingApi
        .getBHPersonalTest(blockId, testId)
        .then((response) => {
          context.commit(mutationTypes.getBHPersonalTestSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getBHPersonalTestFailure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getBHPersonalQuestion](context, {blockId, questionId}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getBHPersonalQuestionStart);
      testingApi
        .getBHPersonalQuestion(blockId, questionId)
        .then((response) => {
          context.commit(mutationTypes.getBHPersonalQuestionSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getBHPersonalQuestionFailure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getUrlPersonalTest](context, {userId, testId}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getUrlPersonalTestStart);
      testingApi
        .getUrlPersonalTest(userId, testId)
        .then((response) => {
          context.commit(mutationTypes.getUrlPersonalTestSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getUrlPersonalTestFailure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getLinkPersonalReport](context, {userId, sessionUid}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getLinkPersonalReportStart);
      testingApi
        .getLinkPersonalReport(userId, sessionUid)
        .then((response) => {
          context.commit(mutationTypes.getLinkPersonalReportSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getLinkPersonalReportFailure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getVariantsPersonalReport](context, {userId, sessionUid}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getVariantsPersonalReportStart);
      testingApi
        .getVariantsPersonalReport(userId, sessionUid)
        .then((response) => {
          context.commit(mutationTypes.getVariantsPersonalReportSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getVariantsPersonalReportFailure,
            result.response.data.message
          );
          reject(result);
        });
    });
  },
  [actionsTypes.exportPersonalReport](context, {userId, sessionUid, variantId}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.exportPersonalReportStart);
      testingApi
        .exportPersonalReport(userId, sessionUid, variantId)
        .then((response) => {
          context.commit(mutationTypes.exportPersonalReportSuccess);
          resolve(response);
        })
        .catch((result) => {
          context.commit(mutationTypes.exportPersonalReportFailure, result.response.status);
          reject(result);
        });
    });
  },

  [actionsTypes.getUserSurveys](context) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getUserSurveysStart);
      testingApi
        .getUserSurveys()
        .then((response) => {
          context.commit(mutationTypes.getUserSurveysSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getUserSurveysFailure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getUserTests](context) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getUserTestsStart);
      testingApi
        .getUserSurveys(true)
        .then((response) => {
          context.commit(mutationTypes.getUserTestsSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getUserTestsFailure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.getUserFeedbacks](context) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getUserFeedbacksStart);
      testingApi
        .getUserSurveys(false, 'feedback')
        .then((response) => {
          context.commit(mutationTypes.getUserFeedbacksSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getUserFeedbacksFailure, result.response.data.message);
          reject(result);
        });
    });
  },

  [actionsTypes.saveAnswer](context, {userId, bpId, data}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.saveAnswerStart);
      testingApi
        .saveAnswer(userId, bpId, data)
        .then((response) => {
          context.commit(mutationTypes.saveAnswerSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.saveAnswerFailure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.saveOpenQuestionsAnswers](context, {test360Id, data}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.saveOpenQuestionsAnswersStart);
      testingApi
        .saveOpenQuestionsAnswers(test360Id, data)
        .then((response) => {
          context.commit(mutationTypes.saveOpenQuestionsAnswersSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(
            mutationTypes.saveOpenQuestionsAnswersFailure,
            result.response.data.message
          );
          reject(result);
        });
    });
  },
  [actionsTypes.saveBHPersonalAnswer](context, {blockId, data}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.saveBHPersonalAnswerStart);
      testingApi
        .saveBHPersonalAnswer(blockId, data)
        .then((response) => {
          context.commit(mutationTypes.saveBHPersonalAnswerSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.saveBHPersonalAnswerFailure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.keepAliveBHPersonalTest](context, {testId, data}) {
    return new Promise((resolve) => {
      testingApi
        .keepAliveBHPersonalTest(testId, data)
        .then((response) => {
          context.commit(mutationTypes.keepAliveBHPersonalTestResult, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.keepAliveBHPersonalTestResult, result.response.data);
          resolve(result.response.data);
        });
    });
  },
  [actionsTypes.resetAnswers](context, {userId, specId, blockId}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.resetAnswersStart);
      testingApi
        .resetAnswers(userId, specId, blockId)
        .then((response) => {
          context.commit(mutationTypes.resetAnswersSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.resetAnswersFailure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.saveResults](context, {userId, specId, blockId, data, completion}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.saveResultsStart);
      testingApi
        .saveResults(userId, specId, blockId, data, completion)
        .then((response) => {
          context.commit(mutationTypes.saveResultsSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.saveResultsFailure, result.response.status);
          reject(result);
        });
    });
  },
  [actionsTypes.createReport](context, {userId, specCode, skillType}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.createReportStart);
      testingApi
        .createReport(userId, specCode, skillType)
        .then((response) => {
          context.commit(mutationTypes.createReportSuccess, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.createReportFailure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.approveTest360](context, {test360Id, data}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.approveTest360Start);
      testingApi
        .approveTest360(test360Id, data)
        .then((response) => {
          context.commit(mutationTypes.approveTest360Success);
          resolve(response);
        })
        .catch((result) => {
          context.commit(mutationTypes.approveTest360Failure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.setDescriptionTest360](context, {test360Id, data}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.setDescriptionTest360Start);
      testingApi
        .setDescriptionTest360(test360Id, data)
        .then((response) => {
          context.commit(mutationTypes.setDescriptionTest360Success);
          resolve(response);
        })
        .catch((result) => {
          context.commit(mutationTypes.setDescriptionTest360Failure, result.response.data.message);
          reject(result);
        });
    });
  },

  [actionsTypes.getRejectsTest360](context, test360Id) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getRejectsTest360Start);
      testingApi
        .getRejectsTest360(test360Id)
        .then((response) => {
          context.commit(mutationTypes.getRejectsTest360Success, response.data);
          resolve(response.data);
        })
        .catch((result) => {
          context.commit(mutationTypes.getRejectsTest360Failure, result.response.data.message);
          reject(result);
        });
    });
  },
  [actionsTypes.rejectTest360](context, {test360Id, data}) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.rejectTest360Start);
      testingApi
        .rejectTest360(test360Id, data)
        .then((response) => {
          context.commit(mutationTypes.rejectTest360Success);
          resolve(response);
        })
        .catch((result) => {
          context.commit(mutationTypes.rejectTest360Failure, result.response.data.message);
          reject(result);
        });
    });
  },
};

export default actions;
